import AuthService from '@/services/auth.service'
const auth = new AuthService()
const state = {
  name: '',
  token: '',
  isauthenticated: false,
  activeNav: 'home',
  tabStatus: ''
}

const mutations = {
  SET_USER: (state, user) => {
    state.isauthenticated = (user !== null)
    if (state.isauthenticated) {
      state.name = user.userName
    }
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ACTIVE_NAV: (state, activenav) => {
    state.activeNav = activenav
  },
  SET_TAB_STATUS: (state, status) => {
    state.tabStatus = status
  }
}

const actions = {
  login({ commit }) {
    return new Promise((resolve, reject) => {
      auth.login().then(
        user => {
          // debugger
          if (user) {
            commit('SET_USER', user)
          } else {
            commit('SET_USER', null)
          }
          resolve()
        }).catch(
        (error) => {
          // debugger
          console.error(error)
          reject()
        })
    })
  },
  logout({ commit }) {
    return new Promise(resolve => {
      auth.logout()
      commit('SET_USER', null)
      resolve()
    })
  },
  setactiveNav({ commit }, activeNav) {
    return new Promise(resolve => {
      commit('SET_ACTIVE_NAV', activeNav)
      resolve()
    })
  },
  getTabStatus({ commit }, status) {
    commit('SET_TAB_STATUS', status)
  },
  gettoken({ commit }) {
    return new Promise((resolve, reject) => {
      auth.getToken().then(
        token => {
          commit('SET_USER', token.account)
          commit('SET_TOKEN', token.accessToken)
          resolve()
        }
      ).catch(
        () => {
          // debugger
          console.log('invalid user')
          commit('SET_USER', null)
          reject()
        })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
